import React, { useEffect, useState } from 'react';
import GenericTable from '../../commun/GenericTable';
import Pagination from '../../commun/Pagination';
import HeaderEntreprise from '../../header/headerEntreprise';
import Footer from '../../commun/Footer';
import StatusTabs from '../../commun/StatusTabs';

const FacturesEntreprise = () => {
  const [factures, setFactures] = useState([]);
  const [page, setPage] = useState(1);
  const [displayMode, setDisplayMode] = useState('table');
  const [visibleCount, setVisibleCount] = useState(8);
  const itemsPerPage = 8;

  const entrepriseName = localStorage.getItem('entrepriseName');
  const authToken = localStorage.getItem('authToken');
  const userId = localStorage.getItem('userId');
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const [filteredStatus, setFilteredStatus] = useState(null);
  const [grouped, setGrouped] = useState({});

  const factureStatuts = [
    {
      value: 'Payée',
      label: 'Payée',
      style: {
        backgroundColor: 'green',
        color: 'white',
        padding: '2px 6px',
        borderRadius: '4px',
      },
    },
    {
      value: 'Non payée',
      label: 'Non payée',
      style: {
        backgroundColor: 'red',
        color: 'white',
        padding: '2px 6px',
        borderRadius: '4px',
      },
    },
  ];

  useEffect(() => {
    const fetchFactures = async () => {
      try {
        const entrepriseId = localStorage.getItem('entrepriseId');
        const res = await fetch(`${API_BASE}/api/entreprise/facture/${entrepriseId}`, {
          headers: { Authorization: `Bearer ${authToken}` },
        });
        const data = await res.json();
        setFactures(data);

        // Grouping for StatusTabs
        const group = {
            Payée: data.filter((f) => f.statutPaiement === 'Payée'),
            'Non payée': data.filter((f) => f.statutPaiement === 'Non payée'),
        };
        setGrouped(group);
      } catch (err) {
        console.error('Erreur chargement factures:', err);
      }
    };

    fetchFactures();
  }, [authToken]);

  useEffect(() => {
    setPage(1);
    setVisibleCount(8);
  }, [filteredStatus]);

  const columns = [
    { key: 'numeroFacture', label: 'Facture #' },
    { key: 'mission', label: 'Mission' },
    { key: 'recruteur', label: 'Recruteur' },
    { key: 'montant', label: 'Montant' },
    { key: 'statut', label: 'Statut' },
    { key: 'dateCreation', label: 'Date de création' },
  ];

  // 🔍 Apply filter by status
  const filteredFactures =
    filteredStatus === null
      ? factures
      : factures.filter((f) =>
          filteredStatus === 'Payée' ? f.statutPaiement === 'Payée' : f.statutPaiement === 'Non payée'
        );

  const formatFactures = (list) =>
    list.map((f) => {
      const statut = factureStatuts.find((s) => s.label === (f.paye ? 'Payée' : 'Non payée'));

      return {
        numeroFacture: f.numeroFacture,
        mission: f.mission?.nomMission || 'N/A',
        recruteur: f.recruteur
          ? `${f.recruteur.firstName} ${f.recruteur.lastName}`
          : 'N/A',
        montant: `${f.montant} €`,
        statut: (
          <span style={statut?.style}>
            {statut?.label || 'Statut inconnu'}
          </span>
        ),
        dateCreation: new Date(f.dateCreation).toLocaleDateString('fr-FR'),
        _id: f._id,
      };
    });

  const formattedData = formatFactures(filteredFactures);
  const paginated = formattedData.slice((page - 1) * itemsPerPage, page * itemsPerPage);
  const cardData = formattedData.slice(0, visibleCount);

  const renderActions = (row) => (
    <button onClick={() => console.log('Voir facture', row)} className="btn-detail">
      Voir détails
    </button>
  );

  return (
    <div className="entreprise-page">
      <HeaderEntreprise entrepriseName={entrepriseName} authToken={authToken} userId={userId} />

      <main className="pageContainer">
        <h2 className="pageTitle">Mes factures</h2>

        <StatusTabs
          statuses={grouped}
          activeStatus={filteredStatus}
          onStatusChange={setFilteredStatus}
          statusStylesSource={factureStatuts}
        />

        <GenericTable
          displayMode={displayMode}
          setDisplayMode={setDisplayMode}
          columns={columns}
          data={displayMode === 'card' ? cardData : paginated}
          renderActions={renderActions}
          totalItems={displayMode === 'card' ? cardData.length : filteredFactures.length}
        />

        {displayMode === 'table' && (
          <Pagination
            page={page}
            setPage={setPage}
            totalItems={filteredFactures.length}
            itemsPerPage={itemsPerPage}
          />
        )}

        {displayMode === 'card' && visibleCount < filteredFactures.length && (
          <div style={{ textAlign: 'center', marginTop: 20 }}>
            <button onClick={() => setVisibleCount((v) => v + 8)} className="btn-charger-plus">
              Charger plus
            </button>
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
};

export default FacturesEntreprise;
